"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var AudioDownloadsControl_1 = __importDefault(require("./AudioDownloadsControl"));
var AudioPlayControl_1 = __importDefault(require("./AudioPlayControl"));
var AudioVolumeControl_1 = __importDefault(require("./AudioVolumeControl"));
var actions_1 = require("./state/actions");
var helpers_1 = require("./state/helpers");
var player_1 = __importDefault(require("./state/player"));
var reducer_1 = __importDefault(require("./state/reducer"));
var inititalState = {
    player: {
        status: player_1.default.STATUS.PAUSE,
        volume: {
            status: player_1.default.VOLUME.STATUS.UNMUTE,
            value: player_1.default.VOLUME.DEFAULT_VALUE,
        },
        duration: 0,
        progress: 0,
        current: 0,
        loop: false,
        autoplay: false,
    },
};
exports.useComponentStyles = core_1.makeStyles(function (theme) {
    var elevations = {};
    theme.shadows.forEach(function (shadow, index) {
        elevations["elevation" + index] = {
            boxShadow: shadow,
        };
    });
    return __assign({ root: function (props) { return ({
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            width: props.width,
            height: props.height,
            transition: theme.transitions.create('box-shadow'),
        }); }, sliderContainerWrapper: function (props) { return ({
            width: 'auto',
            flex: '1 1 auto',
            display: 'flex',
            boxSizing: 'border-box',
            order: props.componentsOrder,
        }); }, sliderContainer: {
            flex: '1 1 auto',
        }, slider: function (props) { return ({
            color: props.playerColors.active,
        }); }, commonContainer: {
            flex: '0 0 auto',
            '&:hover': {
                cursor: 'pointer',
            },
        }, iconSelected: function (props) { return ({
            color: props.playerColors.selected,
        }); }, icon: function (props) { return ({
            color: props.playerColors.active,
            '&:hover': {
                color: props.playerColors.hover,
            },
        }); }, rounded: {
            borderRadius: theme.shape.borderRadius,
        } }, elevations);
});
var AudioPlayerComponentsOrder;
(function (AudioPlayerComponentsOrder) {
    AudioPlayerComponentsOrder["standart"] = "standart";
    AudioPlayerComponentsOrder["reverse"] = "reverse";
})(AudioPlayerComponentsOrder = exports.AudioPlayerComponentsOrder || (exports.AudioPlayerComponentsOrder = {}));
exports.getColors = function (theme, variation) {
    if (variation === AudioPlayerVariation.default) {
        return {
            active: theme.palette.action.active,
            selected: theme.palette.action.selected,
            disabled: theme.palette.action.disabled,
            hover: theme.palette.action.hover,
        };
    }
    else {
        return {
            active: theme.palette[variation].main,
            selected: theme.palette[variation].dark,
            disabled: theme.palette[variation].light,
            hover: theme.palette[variation].light,
        };
    }
};
var AudioPlayerVariation;
(function (AudioPlayerVariation) {
    AudioPlayerVariation["primary"] = "primary";
    AudioPlayerVariation["secondary"] = "secondary";
    AudioPlayerVariation["default"] = "default";
})(AudioPlayerVariation = exports.AudioPlayerVariation || (exports.AudioPlayerVariation = {}));
var AudioPlayerPreload;
(function (AudioPlayerPreload) {
    AudioPlayerPreload["auto"] = "auto";
    AudioPlayerPreload["metadata"] = "metadata";
    AudioPlayerPreload["none"] = "none";
})(AudioPlayerPreload || (AudioPlayerPreload = {}));
var AudioPlayer = function (_a) {
    var _b, _c;
    var src = _a.src, _d = _a.rounded, rounded = _d === void 0 ? true : _d, _e = _a.elevation, elevation = _e === void 0 ? 1 : _e, _f = _a.useStyles, useStyles = _f === void 0 ? function () { return ({}); } : _f, _g = _a.width, width = _g === void 0 ? '100%' : _g, _h = _a.height, height = _h === void 0 ? 'auto' : _h, _j = _a.variation, variation = _j === void 0 ? AudioPlayerVariation.default : _j, _k = _a.preload, preload = _k === void 0 ? AudioPlayerPreload.auto : _k, _l = _a.download, download = _l === void 0 ? false : _l, _m = _a.autoplay, autoplay = _m === void 0 ? false : _m, _o = _a.order, order = _o === void 0 ? AudioPlayerComponentsOrder.standart : _o, _p = _a.loop, loop = _p === void 0 ? false : _p, _q = _a.debug, debug = _q === void 0 ? false : _q, _r = _a.spacing, spacing = _r === void 0 ? undefined : _r, icons = _a.icons;
    var player = React.useRef(null);
    var theme = core_1.useTheme();
    var playerColors = exports.getColors(theme, variation);
    var componentsOrder = order === AudioPlayerComponentsOrder.standart ? 'unset' : '-1';
    var componentStyles = { width: width, height: height, playerColors: playerColors, componentsOrder: componentsOrder };
    var classes = exports.useComponentStyles(componentStyles);
    var classNames = useStyles(componentStyles);
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var _s = React.useReducer(reducer_1.default, inititalState), state = _s[0], dispatch = _s[1];
    var _t = React.useMemo(function () {
        return helpers_1.populateDispatch.apply(void 0, __spreadArrays([dispatch, player], actions_1.actionCreators));
    }, [dispatch, player, actions_1.actionCreators]), _playAudio = _t[0], _pauseAudio = _t[1], _muteAudio = _t[2], _unmuteAudio = _t[3], _changeAudioVolume = _t[4], _setPlayerDuration = _t[5], _setPlayerTime = _t[6], _audioEnded = _t[7], _replayAudio = _t[8], _changePlayerSlider = _t[9], _setPlayerAutoplay = _t[10], _loopAudio = _t[11];
    var handleAudioSliderChange = function (event, progress) {
        _changePlayerSlider(progress);
    };
    var handlePlayerTimeUpdate = function () {
        _setPlayerTime();
    };
    React.useEffect(function () {
        if (player && player.current) {
            if (player.current.readyState > 3) {
                _setPlayerDuration();
            }
            if (!player.current.autoplay && autoplay) {
                _setPlayerAutoplay();
            }
            player.current.addEventListener('canplay', function () {
                _setPlayerDuration();
            });
            player.current.addEventListener('timeupdate', handlePlayerTimeUpdate);
            player.current.addEventListener('ended', _audioEnded);
        }
        return function () {
            if (player && player.current) {
                player.current.removeEventListener('canplay', _setPlayerDuration);
                player.current.removeEventListener('timeupdate', handlePlayerTimeUpdate);
                player.current.removeEventListener('ended', _audioEnded);
            }
        };
    }, [player, src]);
    if (debug) {
        console.log('state', state);
        console.log('player', player);
    }
    var handleLoop = function () {
        _loopAudio(!state.player.loop);
    };
    var mainContainerSpacing = spacing
        ? spacing
        : isMobile
            ? 2
            : 3;
    var audioKey = Array.isArray(src) ? src[0] : src;
    return (React.createElement(core_1.Grid, { container: true, spacing: mainContainerSpacing, component: core_1.Paper, alignItems: "center", className: classnames_1.default(classes.root, classes["elevation" + elevation], (_b = {},
            _b[classes.rounded] = !rounded,
            _b), classNames.root) },
        React.createElement("audio", { ref: player, hidden: true, preload: preload, key: audioKey }, Array.isArray(src) ? (src.map(function (srcLink, index) { return React.createElement("source", { key: index, src: srcLink }); })) : (React.createElement("source", { src: src }))),
        loop && (React.createElement(core_1.Grid, { item: true, className: classes.commonContainer },
            React.createElement(icons_1.Repeat, { fontSize: "large", onClick: handleLoop, className: classnames_1.default((_c = {},
                    _c[classes.iconSelected] = state.player.loop,
                    _c.selected = state.player.loop,
                    _c[classes.icon] = !state.player.loop,
                    _c), classNames.loopIcon) }))),
        React.createElement(core_1.Grid, { item: true, className: classes.commonContainer },
            React.createElement(AudioPlayControl_1.default, { classNames: classNames, icons: icons, playerStatus: state.player.status, playerColors: playerColors, replayAudio: _replayAudio, pauseAudio: _pauseAudio, playAudio: _playAudio })),
        download && (React.createElement(AudioDownloadsControl_1.default, { src: src, playerColors: playerColors })),
        React.createElement(AudioVolumeControl_1.default, { muteAudio: _muteAudio, unmuteAudio: _unmuteAudio, classNames: classNames, changeAudioVolume: _changeAudioVolume, volume: state.player.volume, playerColors: playerColors }),
        React.createElement(core_1.Grid, { item: true, container: true, spacing: 2, className: classnames_1.default(classes.sliderContainerWrapper) },
            React.createElement(core_1.Grid, { item: true, className: classnames_1.default(classes.commonContainer) },
                React.createElement(core_1.Typography, { className: classNames.progressTime }, helpers_1.getFormattedTime(state.player.current))),
            React.createElement(core_1.Grid, { item: true, className: classes.sliderContainer },
                React.createElement(core_1.Slider, { className: classnames_1.default(classes.slider, classNames.mainSlider), onChange: handleAudioSliderChange, value: state.player.progress })),
            React.createElement(core_1.Grid, { item: true, className: classes.commonContainer },
                React.createElement(core_1.Typography, { className: classNames.progressTime }, helpers_1.getFormattedTime(state.player.duration))))));
};
exports.default = AudioPlayer;
//# sourceMappingURL=AudioPlayer.js.map